import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toBool',
  standalone: false,
})
export class ToBoolPipe implements PipeTransform {
  transform(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'string' && value.toLowerCase() === 'true') {
      return true;
    }
    return false;
  }
}
